<!-- register assistant -->
<div class="panel text-black dark:text-white" *ngIf="isModalOpen">
  <div class="">
    <div class="flex items-center justify-center">
      <!-- Botón directamente visible -->
      <!-- <button class="btn btn-primary" (click)="openModal()">Abrir Modal de Registro</button> -->
    </div>
  </div>
</div>
<!-- Este div se mantiene para compatibilidad con código existente -->
<div></div>
